import React, { useState, Component } from 'react';
import * as moment from 'moment';
import { render } from 'react-dom';
import { Button } from '@scuf/common';
const UseTabs = ({ tabs //array objetos {id,title}
    , callback, isTop = true }) => {

    const [array, setArray] = useState(tabs);
    const [selected, setSelected] = useState(tabs[0]);

    const selectedObj = (x) => {
        setSelected(x);
        if (callback) {
            callback(x);
        }

    }
    return (<div className={isTop ? 'not-color-card tab-fixed-card tab1' : 'not-color-card tab-fixed-card tab2'} >
            <div className='tab-container'>
                {
                    array.map((x, key) =>

                        <div style={{width:'max-content'}} key={key} className={x.id == selected.id ? 'tab selected' : 'tab'}
                            onClick={() => selectedObj(x)}>
                            {x.title}
                        </div>
                    )
                }
            </div>
        </div>)
}

export default UseTabs;